import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

type PanelHeaderProps = {
  title: string;
  actions?: React.ReactNode;
  className?: string;
};

export function PanelHeader({ actions, className = 'fleet-panel-head', title }: PanelHeaderProps) {
  return (
    <Box className={className}>
      <Typography component="h2" variant="h2">{title}</Typography>
      {actions}
    </Box>
  );
}
